import BrandLogo from "@/components/BrandLogo";

const sections = [
  {
    title: "Information We Collect",
    body: [
      "Account and profile information, including your name, email address, phone number, emergency contact details, role information and availability.",
      "Event operations information, including event assignments, schedules, travel details, clock-in/out records, task progress, training status, documents and notification preferences.",
      "Technical information needed to operate and secure the service, including device registration tokens for push notifications, authentication events, audit logs, error diagnostics and basic usage information.",
    ],
  },
  {
    title: "How We Use Information",
    body: [
      "To provide event staffing, scheduling, document, training, notification and operational management features.",
      "To communicate important event updates and account notices.",
      "To protect the security, integrity and reliability of the Seiko Event Portal.",
      "To support internal administration, compliance, audit and event delivery workflows.",
    ],
  },
  {
    title: "Sharing",
    body: [
      "Information is used by authorised Seiko personnel, event managers and operational support teams where needed to deliver events and manage staff workflows.",
      "We use trusted service providers for hosting, authentication, storage, email delivery, notifications, diagnostics and related operational services.",
      "We do not sell personal information.",
    ],
  },
  {
    title: "Retention And Access",
    body: [
      "We retain information for as long as needed to operate the portal, support event delivery, meet legal or compliance requirements and maintain business records.",
      "You can request account deletion in My Profile or from the awaiting acceptance screen. A manager must confirm your departure and approve deletion before your account, personal documents and associated portal records are removed. We retain the deletion request and manager decision as a departure record. Contact Seiko Sports Tech for other access or correction requests.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-900">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-4xl flex-col gap-6 px-6 py-10">
          <div className="w-64 rounded-lg bg-black p-4">
            <BrandLogo alt="Seiko Sports Technologies" className="h-auto w-full" />
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-wide text-slate-500">Seiko Event Portal</p>
            <h1 className="mt-2 text-4xl font-bold tracking-tight">Privacy Policy</h1>
            <p className="mt-4 max-w-2xl text-base leading-7 text-slate-600">
              This policy explains how Seiko Sports Tech handles information in the Seiko Event Portal.
              The portal is for authorised event staff, contractors and managers.
            </p>
          </div>
          <p className="text-sm text-slate-500">Last updated: 8 September 2026</p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-6 py-10">
        <div className="space-y-8">
          {sections.map((section) => (
            <section key={section.title} className="rounded-lg border border-slate-200 bg-white p-6">
              <h2 className="text-xl font-semibold">{section.title}</h2>
              <ul className="mt-4 list-disc space-y-3 pl-5 text-sm leading-6 text-slate-600">
                {section.body.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </section>
          ))}

          <section className="rounded-lg border border-slate-200 bg-white p-6">
            <h2 className="text-xl font-semibold">Contact</h2>
            <p className="mt-4 text-sm leading-6 text-slate-600">
              For privacy questions or requests, contact Seiko Sports Tech at{" "}
              <a className="font-medium text-slate-900 underline" href="mailto:shaun.barratt@seikosportstech.co.uk">
                shaun.barratt@seikosportstech.co.uk
              </a>
              .
            </p>
          </section>
        </div>
      </section>
    </main>
  );
}
